import React, {FC, ReactNode} from "react";
import {Box} from "@leap4/frontend";

const KeyValueContainer: FC<{ title: string, value: ReactNode }> = ({ title, value}) => {
    return <Box sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: "center",
        marginBottom: "1.5vh",
        justifyContent: { xs: "center", sm: "space-between" },
        fontSize: "xx-larger",
        gap: "4px",
        width: "100%"
    }}>
        <Box component="span" sx={{ 
            whiteSpace: "nowrap", 
            textAlign: "center",
            width: { xs: "100%", sm: "auto" }
        }}>{title}</Box>
        <Box component="span" sx={{ 
            textAlign: "center",
            width: { xs: "100%", sm: "auto" },
            display: "flex",
            justifyContent: "center"
        }}>{value}</Box>
    </Box>
}

export default KeyValueContainer;
